(function () {
    'use strict';

    angular
        .module('elogbooks.admin.sites')
        .controller('SiteInfoController', SiteInfoController);

    SiteInfoController.$inject = [
        '$state',
        'apiClient',
        'confirmationModal',
        'siteResponse',
        'isActive',
        'messenger','lodash',
        'quoteThresholdsCollectionResponse',
        'thresholdService',
        'approversResponse',
        'modulesService',
        'isEditable',
        'meridianConfigurationCollectionResponse',
        'userManager',
        'siteAssociatesService',
        'rootResourceResponse',
        '$scope'
    ];

    function SiteInfoController(
        $state,
        apiClient,
        confirmationModal,
        siteResponse,
        isActive,
        messenger,
        lodash,
        quoteThresholdsCollectionResponse,
        thresholdService,
        approversResponse,
        modulesService,
        isEditable,
        meridianConfigurationCollectionResponse,
        userManager,
        siteAssociatesService,
        rootResourceResponse,
        $scope
    )
        {
        var vm = this;
        vm.delete = deleteSite;
        vm.site = siteResponse;
        vm.isActive = isActive;
        vm.pcdEnabled = modulesService.isEnabled('pcd');
        vm.p2pProactisEnabled = modulesService.isEnabled('p2p');
        vm.p2pHexagonEnabled = modulesService.isEnabled('hexagon_p2p');
        vm.p2pEnabled = vm.p2pProactisEnabled || vm.p2pHexagonEnabled;
        vm.dataStationTypeEnabled = modulesService.isEnabled('datastation');
        vm.riskwiseEnabled = modulesService.isEnabled('riskwise');
        vm.multiMeridian =  lodash.get(meridianConfigurationCollectionResponse, 'systemLinks', []).length;
        vm.associatesCollectionLoading = true;
        vm.associatesCollection = siteAssociatesService.getSiteAssociates(siteResponse, rootResourceResponse, {limit: 999});
        vm.quoteThresholds = quoteThresholdsCollectionResponse.quoteThresholds;
        vm.approvers = approversResponse;
        vm.address = siteResponse.contactInformation.addresses[0];
        vm.canEditSite = isEditable;
        vm.canAccessAssociates = siteResponse.getLink('memberships') && siteResponse.getLink('associates');
        vm.isClientAdmin = userManager.hasPermission('user_permission_client_admin_manage_sites') && !userManager.hasPermission('user_permission_view_sites');
        vm.tasksModuleEnabled = modulesService.isEnabled('tasks_module');

        vm.approverTypes = {
            reactiveJobApprovers: 'REACTIVE_JOB_APPROVERS',
            reactiveJobExtensionsApprovers: 'REACTIVE_JOB_EXTENSIONS_APPROVERS',
            ...(vm.tasksModuleEnabled && {
                plannedJobApprovers:   'PLANNED_JOB_APPROVERS',
                plannedJobExtensionsApprovers: 'PLANNED_JOB_EXTENSIONS_APPROVERS'
            })
        };

        if (modulesService.isEnabled('quotes')) {
            vm.approverTypes.quoteApprovers = 'QUOTE_APPROVERS';
        }


        if (modulesService.isEnabled('contracts_module')) {
            vm.approverTypes.contractApprovers = 'CONTRACT_APPROVERS';
        }

        if (modulesService.isEnabled('surveys_module')) {
            vm.approverTypes.surveyApprovers = 'SURVEY_APPROVERS';
        }

        thresholdService.initThresholds(vm.quoteThresholds);
        vm.getQuoteApproverThreshold = thresholdService.getQuoteApproverThreshold;

        $scope.$watch('vm.associatesCollection.length', function(newVal, oldVal) {
            if(newVal !== oldVal && newVal !== 0) {
                vm.associatesCollectionLoading = false;
            }
        }, true);

        function deleteSite() {
            return confirmationModal.open().result.then(
                function () {
                    return apiClient.delete(vm.site.getLink('delete')).then(function (response) {
                        if (response) {
                            $state.go('dashboard.admin.sites.list', {}, { reload: true }).then(function () {
                                messenger.success('SITE_DELETED');
                            });
                        } else {
                            messenger.error('REQUEST_ERROR');
                        }
                    });
                }
            );
        };
    }
})();
